<lib-dialog-layout>

    <ng-container content>
        @if (hasSaveMethod) {
            <p [ngClass]="{'text-center': isMobile}" i18n="@@CommonUnsavedFormChangesSaveNContinueDialogText">
                Would you like to save or discard your changes before continuing?
            </p>
        }
        @if (!hasSaveMethod) {
            <p [ngClass]="{'text-center': isMobile}" i18n="@@CommonUnsavedFormChangesDiscardDialogText">
                Are you sure you want to continue and discard unsaved changes?
            </p>
        }
    </ng-container>

    <ng-container title i18n="@@CommonUnsavedFormChangesDialogTitle">
        Unsaved Changes
    </ng-container>

    <ng-container submissionBar>
        @if (hasSaveMethod) {
            <lib-submission-bar [kind]="SubmissionBarKind.DialogBasic">
                <lib-button
                [role]="ButtonRole.Primary"
                    id="LibraryDialogPrimaryButton"
                    [loading]="primaryActionClicked || secondaryActionClicked"
                    qaTag="unsaved-form-changes-dialog-save-button"
                    (clicked)="PrimaryAction()">
                    <ng-container label i18n="@@CommonSaveButton">
                        Save
                    </ng-container>
                </lib-button>
                <lib-button
                [role]="ButtonRole.Secondary"
                    id="LibraryDialogBackButton"
                    [kind]="ButtonKind.NeutralSecondary"
                    [disabled]="primaryActionClicked || secondaryActionClicked"
                    qaTag="unsaved-form-changes-dialog-cancel-button"
                    (clicked)="DismissAction()">
                    <ng-container label i18n="@@CommonCancelButton">
                        Cancel
                    </ng-container>
                </lib-button>
                <lib-button
                [role]="ButtonRole.Tertiary"
                    id="LibraryDialogSecondaryButton"
                    [kind]="ButtonKind.Secondary"
                    [disabled]="primaryActionClicked || secondaryActionClicked"
                    qaTag="unsaved-form-changes-dialog-do-not-save-button"
                    (clicked)="SecondaryAction()">
                    <ng-container label i18n="@@CommonDonotSaveButton">
                        Don't Save
                    </ng-container>
                </lib-button>
            </lib-submission-bar>
        } @else {
            <lib-submission-bar [kind]="SubmissionBarKind.DialogBasic">
                <lib-button
                [role]="ButtonRole.Primary"
                    id="LibraryDialogPrimaryButton"
                    [disabled]="primaryActionClicked"
                    qaTag="unsaved-form-changes-primary-action-button"
                    (clicked)="PrimaryAction()">
                    <ng-container label i18n="@@CommonUnsavedFormChangesDialogContinueWithoutSaving">
                        Continue Without Saving
                    </ng-container>
                </lib-button>
                <lib-button
                [role]="ButtonRole.Secondary"
                    id="LibraryDialogSecondaryButton"
                    [kind]="ButtonKind.Secondary"
                    [disabled]="primaryActionClicked"
                    qaTag="unsaved-form-changes-dialog-dismiss-action-button"
                    (clicked)="DismissAction()">
                    <ng-container label i18n="@@CommonGoBackButton">
                        Go Back
                    </ng-container>
                </lib-button>
            </lib-submission-bar>
        }
    </ng-container>
</lib-dialog-layout>